import React, { useEffect, useState } from "react";
import { FiUsers, FiAward, FiTrendingUp } from "react-icons/fi";
import { motion } from "framer-motion";
import axios from "axios";
import { DEFAULT_ROUTE } from "../../routes/api/api_routes"; // Ajuste le chemin si nécessaire

const StatsRow = ({ totalBakelistes, bestScores, successRate }) => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem("access");
        const res = await axios.get(`${DEFAULT_ROUTE}users/`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        console.log("Utilisateurs récupérés :", res.data); // Vérification
        setUsers(res.data);
      } catch (err) {
        console.error("Erreur lors de la récupération des utilisateurs :", err);
      }
    };

    fetchUsers();
  }, []);

  const cardVariants = {
    hidden: { opacity: 0, y: -50 },
    visible: (i = 1) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.1, duration: 0.5, ease: "easeOut" },
    }),
  };

  return (
    <div className="flex flex-wrap gap-6">
      {/* Total Bakelistes Card */}
      <motion.div
        className="flex items-center justify-between flex-1 min-w-[250px] p-4 bg-white rounded-lg shadow-sm border border-gray-100 relative"
        initial="hidden"
        animate="visible"
        custom={0}
        variants={cardVariants}
      >
        <div className="absolute top-0 right-0 h-full w-2 bg-orange-400 rounded-tr-lg rounded-br-lg"></div>
        <FiUsers className="text-orange-400 text-3xl" />
        <div className="ml-4">
          <h3 className="text-sm font-semibold text-black">Total Bakelistes</h3>
        </div>
        <p className="ml-auto text-orange-400 font-semibold text-lg">
          {totalBakelistes}
        </p>
      </motion.div>

      {/* Meilleurs Scores Card */}
      <motion.div
        className="flex items-center justify-between flex-1 min-w-[250px] p-4 bg-white rounded-lg shadow-sm border border-gray-100 relative"
        initial="hidden"
        animate="visible"
        custom={1}
        variants={cardVariants}
      >
        <div className="absolute top-0 right-0 h-full w-2 bg-orange-400 rounded-tr-lg rounded-br-lg"></div>
        <FiAward className="text-orange-400 text-3xl" />
        <div className="ml-4">
          <h3 className="text-sm font-semibold text-black">Meilleurs scores</h3>
        </div>
        <p className="ml-auto text-orange-400 font-semibold text-lg">
          {bestScores}
        </p>
      </motion.div>

      {/* Pourcentage réussite Card */}
      <motion.div
        className="flex items-center justify-between flex-1 min-w-[250px] p-4 bg-white rounded-lg shadow-sm border border-gray-100 relative"
        initial="hidden"
        animate="visible"
        custom={2}
        variants={cardVariants}
      >
        <div className="absolute top-0 right-0 h-full w-2 bg-orange-400 rounded-tr-lg rounded-br-lg"></div>
        <FiTrendingUp className="text-orange-400 text-3xl" />
        <div className="ml-4">
          <h3 className="text-sm font-semibold text-black">Taux de réussite</h3>
        </div>
        <p className="ml-auto text-orange-400 font-semibold text-lg">
          {successRate}%
        </p>
      </motion.div>
    </div>
  );
};

export default StatsRow;
